// export const domain = `http://localhost:5000`;
export const domain = `https://dillak.pl`;

export const veneerHandles = [
  'uk45',
  'p45',
  'up45',
  'UK45',
  'UP45',
  'P45',
];
export const veneerExcludedHandles = ['up', 'uc', 'uk', 'UP', 'UC', 'UK'];

export const veneerMillings = ['ryflowany'];

export const statsPositions = [
  'dillak',
  'nowe',
  'surówka',
  'podkład',
  'szlifiernia',
  'lakiernia',
  'polernia',
  'pakowanie',
  'odebrane',
];

export const orderStatuses = [
  'piła',
  'surówka',
  'podkład',
  'szlifiernia',
  'lakiernia',
  'polernia',
  'pakowanie',
  'zakończone',
  'odebrane',
];

export const productionStatuses = [
  'piła',
  'surówka',
  'podkład',
  'szlifiernia',
  'lakiernia',
  'polernia',
  'pakowanie',
  'zakończone',
];

export const employeePositions = [
  'surówka',
  'podkład',
  'szlifiernia',
  'lakiernia',
  'polernia',
  'pakowanie',
  'transport',
];

export const paintTypes = ['półmat', 'mat', 'połysk'];
export const paintStyled = [
  'jednostronne',
  'dwustronne',
  'prawa - połysk / lewa - półmat',
];

export const orderTypes = [
  'Reklamacja (wina DILLAK)',
  'Poprawa (wina klienta)',
  'Domówienie',
  'Materiał klienta',
  'Lista elementów',
];

export const weekDays = [
  'niedziela',
  'poniedziałek',
  'wtorek',
  'środa',
  'czwartek',
  'piątek',
  'sobota',
];

export const months = [
  'styczeń',
  'luty',
  'marzec',
  'kwiecień',
  'maj',
  'czerwiec',
  'lipiec',
  'sierpień',
  'wrzesień',
  'październik',
  'listopad',
  'grudzień',
];

export const reasonsOfComplaint = [
  'paproch',
  'uszkodzenie mechaniczne',
  'uszkodzony laminat',
  'zaciek',
  'element źle polakierowany',
  'niepolakierowana druga strona',
  'przetarcie',
  'zły wymiar',
  'inny',
];
export const cuttingPackageStatus = {
  PENDING: 'oczekuje',
  IN_PROGRESS: 'w trakcie',
  NOT_COMPLETE: 'nie kompletne',
  READY: 'gotowy',
};
export const orderItemCuttingStatus = {
  TO_CUT: 'do wycięcia',
  SUSPENDED: 'wstrzymany',
  SKIPPED: 'pominięty',
  READY: 'gotowy',
};
export const orderItemCuttingStatuses = [
  'do wycięcia',
  'wstrzymany',
  'pominięty',
  'gotowy',
];
